import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useParams } from 'react-router-dom';
import { Typography, List, ListItem } from '@material-ui/core';
import { useRootStore } from '../../../stores/BridgeProvider';
import { CustomTable } from '../../common/CustomTable';
import Spinner from '../../util/Spinner';

const columns = [
  {
    Header: 'Event',
    accessor: d => d.eventDesc,
    Cell: ({ row }) => {
      return row.original.eventDesc.map((item, index) => (
        <span key={item}>
          {item}
          {index !== row.original.eventDesc.length - 1 && ', '}
        </span>
      ));
    },
    id: 1,
  },
  {
    Header: 'Timestamp',
    accessor: d => d.timeStamp,
    Cell: ({ row }) => {
      return moment
        .utc(row.original.timeStamp)
        .local()
        .format('MM/DD/YYYY  hh:mm:ss A');
    },
    id: 2,
  },
  {
    Header: 'Modified By',
    accessor: d => d.modifiedBy,
    id: 3,
  },
];

const DealAuditLog = () => {
  const { authStore } = useRootStore();
  const { dealID } = useParams();

  const [dealLog, setDealLog] = useState([]);
  const [loading, setLoading] = useState(true);

  const getDealHistory = async () => {
    try {
      const { data } = await authStore.request.get(
        `${process.env.REACT_APP_API}/api/deal-history/${dealID}`,
      );
      setDealLog(data);
      setLoading(false);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    getDealHistory();
  }, []);

  if (loading) return <Spinner />;
  return (
    <div>
      <div>
        <CustomTable
          data={dealLog || []}
          columns={columns}
          minRows={1}
          noDataText="No changes logged"
          tableHeader={<Typography variant="h4">Deal History Log</Typography>}
          defaultPageSize={6}
          SubComponent={({ row }) => {
            const rowDetails = Object.entries(row.original.events);
            const { type, events } = row.original;
            return (
              <div>
                <List>
                  {type === 'Deal' &&
                    rowDetails.map(item => {
                      const k = item[0];
                      const v = item[1];
                      return (
                        <ListItem key={k}>
                          <b>{k === 'StatusName' ? 'Status' : k}</b> : {v}
                        </ListItem>
                      );
                    })}
                  {type === 'Transaction' &&
                    events.map(t => {
                      return (
                        <ListItem key={t.id}>
                          {`{Transaction Type: ${t.tranType} , Transaction Category: ${t.tranCategoryCode} ,  Event: ${t.events.Action}}`}
                        </ListItem>
                      );
                    })}
                </List>
              </div>
            );
          }}
        />
      </div>
    </div>
  );
};

export default DealAuditLog;
